import { ROUTES } from "../../../helpers/routes";
import { LANG } from "../../../types/lang";

export const dataFooter = {
  [LANG.EN]: {},

  [LANG.GE]: {},
};

export const routerFooter = [
  {
    name: "Home",
    path: ROUTES.home,
  },
  {
    name: "Abkürzungen",
    path: ROUTES.abbreviation,
  },
  {
    name: "Datenschutz",
    path: ROUTES.dataSecurity,
  },
  {
    name: "AGB",
    path: ROUTES.agb,
  },
  {
    name: "Impressum",
    path: ROUTES.impressum,
  },
];
